import { Box, FlexColumn, Message } from "designSystem/index";
import DojoForm from "csi/page/DojoForm";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { TYPE_HIGG_MATERIAL, useHiggMaterialStore } from "./HiggMaterialStore";

export const HiggMaterialForm: FunctionComponent = observer(() => {
	const { formData, nameViolationRes } = useHiggMaterialStore();

	return (
		<FlexColumn>
			{nameViolationRes && (
				<Box pb={6}>
					<Message titleRes={nameViolationRes} variant="error" />
				</Box>
			)}
			<DojoForm formData={formData} nodeType={TYPE_HIGG_MATERIAL} />
		</FlexColumn>
	);
});

export default HiggMaterialForm;